export default __webpack_public_path__ + "static/technomedics-logo-560fba103bfdd78748ef2ce1e5b93935.png";